import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "file-arae" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center","margin":"0 auto","margin-top":"100px"} }, "File Name Space", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { style: {"text-align":"center","margin":"0 auto"} }, "a decentralized web3 name service for ethereum and filecoin.", -1)
const _hoisted_4 = { style: {"margin":"0 auto","text-align":"center","margin-top":"50px"} }
const _hoisted_5 = {
  key: 0,
  style: {"margin":"0 auto","margin-top":"10px","text-align":"center","width":"585px","border":"solid 1px","border-color":"#67C23A"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"color":"#409EFF"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { style: {"color":"#409EFF"} }, "available", -1)
const _hoisted_9 = {
  key: 1,
  style: {"color":"#E6A23C"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { style: {"color":"#E6A23C"} }, "registerted", -1)

import { ref } from "vue"

import { FileNameSpace } from "../libs/filenamespace"
import * as w3name from "../libs/w3name"

import { networkConnect, connectState } from "../libs/connect"
import * as crypto from "../libs/crypto"
import * as element from "../libs/element"
import * as tools from "../libs/tools"

import * as constant from "../constant"


const __default__ = {
  name: 'MintsPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const searchName = ref('');
const showName = ref(false);
const nameLists = ref(new Array());
const loadRegisterStatus = ref(false);

const filenamespace = new FileNameSpace();

const svg = `
      <path class="path" d="
        M 30 15
        L 28 17
        M 25.61 25.61
        A 15 15, 0, 0, 1, 15 30
        A 15 15, 0, 1, 1, 27.99 7.5
        L 15 15
      " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
    `;

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }
  return transaction;
}    

//address explore url
const tokenExplorerUrl = (address:string, tokenId:string = '') => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      if(tokenId != ''){
        return `${blockExplorerUrls}/token/${address}?a=${tokenId}#inventory`
      }
      return `${blockExplorerUrls}/token/${address}`
    }
  }
  return address;
}  

const onClickToSearch = async () => {
  searchName.value = searchName.value.trim();

  nameLists.value = new Array();
  if(searchName.value === ''){
    showName.value = false;
    return;
  }else{
    showName.value = true;
  }

  const name = searchName.value + constant.nameSpaceSurfix;

  const nameInfo = await filenamespace.getNameInfoByName(name);

  const newList = new Array();
  newList.push(nameInfo);
  nameLists.value = newList;
}

const onClickToRegisterName = async (nameInfo:any) => {
  try {
    loadRegisterStatus.value = true;

    await networkConnect();

    const count = await filenamespace.balanceOf(connectState.userAddr.value);
    if(count > 0){
      element.alertMessage("you have already registered one name!");
      return;
    }

    const name = await w3name.createNewName();

    const publicKey = name.toString();
    const privateKey = await crypto.encryptPasswordWithWallet(tools.uint8ToString(name.key.bytes));

    if(privateKey.sign_data === null || privateKey.sign_data === '' || privateKey.signature === null || privateKey.signature === ''){
      return;
    }

    const tx = await filenamespace.mint(nameInfo.name, '', publicKey, JSON.stringify(privateKey));
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Register name success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       
  }catch(e){
    element.alertMessage(e);
  }finally{
    loadRegisterStatus.value = false;
    onClickToSearch();
  }
}

const onClickToViewNameInfo = async (nameInfo:any) => {
  //parse the redirect url
  connectState.activeIndex.value = '2';

  tools.setUrlParamter('activeIndex', '2');  
  tools.setUrlParamter('nameId', nameInfo.nameId);
}

tools.setUrlParamter('nameId', '0');

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Check = _resolveComponent("Check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_main, { style: {"height":"450px","margin-top":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_input, {
                    modelValue: searchName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchName).value = $event)),
                    placeholder: "Explore the space",
                    style: {"width":"500px"},
                    size: "large",
                    clearable: ""
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode(_toDisplayString(constant.nameSpaceSurfix), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    icon: _ctx.Search,
                    type: "primary",
                    size: "large",
                    onClick: onClickToSearch
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Search")
                    ]),
                    _: 1
                  }, 8, ["icon"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (showName.value)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nameLists.value, (v) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: v.name
                        }, [
                          (v.nameId === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                                _createElementVNode("td", _hoisted_7, [
                                  _createVNode(_component_el_icon, { type: "primary" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Check)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(v.name), 1)
                                ]),
                                _hoisted_8,
                                _createElementVNode("td", null, [
                                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                    type: "primary",
                                    onClick: ($event: any) => (onClickToRegisterName(v)),
                                    "element-loading-text": "Loading...",
                                    "element-loading-spinner": svg,
                                    "element-loading-svg-view-box": "-10, -10, 50, 50",
                                    "element-loading-background": "#00FFD1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Register ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])), [
                                    [_directive_loading, loadRegisterStatus.value]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (v.nameId > 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                                _createElementVNode("td", null, [
                                  _createVNode(_component_el_icon, { type: "warning" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Close)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_link, {
                                    type: "warning",
                                    target: "_blank",
                                    href: tokenExplorerUrl(_unref(filenamespace).getAddress(), v.nameId)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(v.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _hoisted_10,
                                _createElementVNode("td", null, [
                                  _createVNode(_component_el_button, {
                                    type: "warning",
                                    onClick: ($event: any) => (onClickToViewNameInfo(v))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("View")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer)
      ]),
      _: 1
    })
  ]))
}
}

})